import type { ReactNode } from 'react';

const COLOR = { error: 'text-kumo-danger', warning: 'text-kumo-warning', success: 'text-kumo-success', info: 'text-kumo-info', stopped: 'text-kumo-inactive' } as const;

/** Indicador de status: bolinha colorida + texto. */
export function StatusIndicator({ type, children }: { type: keyof typeof COLOR; children: ReactNode }) {
  return <span className={`inline-flex items-center gap-1.5 ${COLOR[type]}`}><span className="inline-block h-2 w-2 rounded-full bg-current" />{children}</span>;
}
